import { useTranslation } from '@frontend/i18n';
import { InsuranceTabDateHeaderV3 } from './InsuranceTabDateHeaderV3';
import { SwitchViewButton } from './SwitchViewButton';
import { ScheduleInsuranceTabTrackingIds } from './trackingIds';

type InsuranceTabDateHeaderProps = {
  type: 'add-to-list' | 'analytics';
};

export const InsuranceTabDateHeader = ({ type }: InsuranceTabDateHeaderProps) => {
  const { t } = useTranslation('schedule-pulse');

  const tooltipMessage = type === 'add-to-list' ? t('Switch to analytics view') : t('Switch to patient list view');
  const view = type === 'add-to-list' ? 'analytics' : 'add-to-list';

  return (
    <InsuranceTabDateHeaderV3
      shouldRenderFilters={type === 'add-to-list'}
      renderAdditionalActionButton={
        <SwitchViewButton
          tooltipMessage={tooltipMessage}
          view={view}
          trackingId={ScheduleInsuranceTabTrackingIds.insuranceTabSwitchButton}
        />
      }
    />
  );
};
